import { render, staticRenderFns } from "./ViewSmsCustomSuccess.vue?vue&type=template&id=5144904c&scoped=true"
import script from "./ViewSmsCustomSuccess.vue?vue&type=script&lang=js"
export * from "./ViewSmsCustomSuccess.vue?vue&type=script&lang=js"
import style0 from "./ViewSmsCustomSuccess.vue?vue&type=style&index=0&id=5144904c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5144904c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5144904c')) {
      api.createRecord('5144904c', component.options)
    } else {
      api.reload('5144904c', component.options)
    }
    module.hot.accept("./ViewSmsCustomSuccess.vue?vue&type=template&id=5144904c&scoped=true", function () {
      api.rerender('5144904c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/ViewSmsCustomSuccess.vue"
export default component.exports